import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AddTransactionModal = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    category: 'membership',
    amount: '',
    description: '',
    transaction_date: new Date()?.toISOString()?.split('T')?.[0]
  });

  const categories = [
    { id: 'membership', label: 'Membership', icon: 'Users' },
    { id: 'class', label: 'Class', icon: 'Calendar' },
    { id: 'personal_training', label: 'Personal Training', icon: 'Dumbbell' },
    { id: 'merchandise', label: 'Merchandise', icon: 'ShoppingBag' },
    { id: 'other', label: 'Other', icon: 'MoreHorizontal' }
  ];

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (!formData?.amount || parseFloat(formData?.amount) <= 0) return;

    onSubmit({
      category: formData?.category,
      amount: parseFloat(formData?.amount),
      description: formData?.description?.trim() || null,
      transaction_date: formData?.transaction_date
    });
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-xl shadow-xl max-w-lg w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h2 className="text-xl font-bold text-foreground">Add Transaction</h2>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-smooth"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6">
          {/* Category */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-foreground mb-3">
              Category
            </label>
            <div className="grid grid-cols-3 gap-2">
              {categories?.map((cat) => (
                <button
                  key={cat?.id}
                  type="button"
                  onClick={() => setFormData({ ...formData, category: cat?.id })}
                  className={`flex flex-col items-center gap-2 p-3 rounded-lg border-2 transition-smooth ${
                    formData?.category === cat?.id
                      ? 'border-primary bg-primary/10' :'border-border hover:border-primary/50'
                  }`}
                >
                  <Icon
                    name={cat?.icon}
                    size={20}
                    className={formData?.category === cat?.id ? 'text-primary' : 'text-muted-foreground'}
                  />
                  <span className={`text-xs font-medium ${
                    formData?.category === cat?.id ? 'text-primary' : 'text-muted-foreground'
                  }`}>
                    {cat?.label}
                  </span>
                </button>
              ))}
            </div>
          </div>

          {/* Amount */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-foreground mb-2">
              Amount *
            </label>
            <div className="relative">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">
                $
              </span>
              <input
                type="number"
                step="0.01"
                min="0"
                value={formData?.amount}
                onChange={(e) => setFormData({ ...formData, amount: e?.target?.value })}
                placeholder="0.00"
                required
                className="w-full pl-8 pr-4 py-3 rounded-lg bg-background border border-border focus:outline-none focus:ring-2 focus:ring-primary text-foreground"
              />
            </div>
          </div>

          {/* Description */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-foreground mb-2">
              Description
            </label>
            <textarea
              value={formData?.description}
              onChange={(e) => setFormData({ ...formData, description: e?.target?.value })}
              placeholder="Enter transaction details..."
              rows={3}
              className="w-full px-4 py-3 rounded-lg bg-background border border-border focus:outline-none focus:ring-2 focus:ring-primary text-foreground resize-none"
            />
          </div>

          {/* Date */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-foreground mb-2">
              Transaction Date *
            </label>
            <input
              type="date"
              value={formData?.transaction_date}
              onChange={(e) => setFormData({ ...formData, transaction_date: e?.target?.value })}
              required
              className="w-full px-4 py-3 rounded-lg bg-background border border-border focus:outline-none focus:ring-2 focus:ring-primary text-foreground"
            />
          </div>

          {/* Actions */}
          <div className="flex items-center justify-end gap-3">
            <Button type="button" variant="ghost" onClick={onClose}>
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={!formData?.amount || parseFloat(formData?.amount) <= 0}
            >
              <Icon name="Plus" size={18} className="mr-2" />
              Add Transaction
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTransactionModal;